import { render, staticRenderFns } from "./BasketPreview.vue?vue&type=template&id=41e55636"
import script from "./BasketPreview.vue?vue&type=script&lang=js"
export * from "./BasketPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports